import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0318 from "../lesson-18/lesson";
import lesson0319 from "../lesson-19/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "a9d45cac-489b-4122-a6df-e226841e664e",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0318),
    lesson: lesson0318,
  },
  {
    id: "a6e1e195-23be-4659-82f9-b38d1bbc3700",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0319),
    lesson: lesson0319,
  },
];

export default lessonLinks;
